import React from "react";
import {
  FaCheckCircle,
  FaClock,
  FaDumbbell,
  FaRunning,
} from "react-icons/fa";

import {
  DEFAULT_PREPA_IMAGE,
  getAdherentName,
} from "../utils/preparationPhysiqueAdherentUtils";

function HeroStat({ icon: Icon, label, value }) {
  return (
    <div className="rounded-[1.5rem] border border-white/10 bg-white/10 p-4 text-white backdrop-blur-xl">
      <Icon className="text-emerald-200" />

      <p className="mt-3 text-2xl font-bold">{value}</p>

      <p className="text-xs font-bold uppercase tracking-[0.14em] text-white/50">
        {label}
      </p>
    </div>
  );
}

function AdherentPrepaHero({ stats, selectedAdherent }) {
  return (
    <header className="relative overflow-hidden bg-slate-950">
      <div className="absolute inset-0">
        <img
          src={DEFAULT_PREPA_IMAGE}
          alt="Préparation physique"
          className="h-full w-full object-cover opacity-75"
        />

        <div className="absolute inset-0 bg-gradient-to-br from-slate-950 via-slate-950/85 to-emerald-950/75" />
      </div>

      <div className="relative mx-auto flex min-h-[380px] w-full max-w-[1280px] flex-col justify-end px-4 pb-20 pt-12 sm:px-6 lg:px-8">
        <div className="max-w-4xl">
          <div className="inline-flex items-center gap-2 rounded-full bg-white/15 px-4 py-2 text-xs font-bold uppercase tracking-[0.16em] text-white backdrop-blur-xl">
            <FaDumbbell />
            Préparation physique
          </div>

          <h1 className="mt-5 font-titre text-4xl font-bold tracking-tight text-white sm:text-5xl lg:text-6xl">
            Exercices à réaliser
          </h1>

          <p className="mt-5 max-w-2xl text-base font-medium leading-8 text-white/75 sm:text-lg">
            {selectedAdherent
              ? `Programme attribué à ${getAdherentName(selectedAdherent)}.`
              : "Sélectionne un judoka pour afficher ses exercices attribués."}
          </p>
        </div>

        <div className="mt-8 grid max-w-4xl gap-3 sm:grid-cols-3">
          <HeroStat icon={FaRunning} label="Total" value={stats.total} />

          <HeroStat icon={FaClock} label="À faire" value={stats.pending} />

          <HeroStat icon={FaCheckCircle} label="Réalisés" value={stats.done} />
        </div>
      </div>
    </header>
  );
}

export default AdherentPrepaHero;